/*
 * Desktop filters drawer
 *
 * The theme already ships the off-canvas filters panel, but only opens it below
 * the `small` breakpoint (see `mobileFiltersScrollLock` in theme.js). This adds
 * the desktop trigger without touching theme.js: it toggles the same
 * `collection__filters--visible` class and fires the same scroll lock events,
 * so the theme's own close button, ESC handler and AJAX re-render keep working.
 */
(function () {
  var selectors = {
    section: '[data-section-type="collection-template"]',
    filters: '[data-collection-filters]',
    filtersList: '[data-collection-filters-list]',
    trigger: '[data-toggle-filters-desktop]'
  };

  var classes = {
    drawerMode: 'collection--filters-drawer',
    visible: 'collection__filters--visible'
  };

  var SCROLL_UNLOCK_DELAY = 300; // matches the theme's own unlock delay

  function isDesktop() {
    var breakpoint =
      window.theme && window.theme.sizes ? window.theme.sizes.small : 768;

    return window.innerWidth >= breakpoint;
  }

  function getFilters(section) {
    return section ? section.querySelector(selectors.filters) : null;
  }

  function open(filters) {
    if (!filters || filters.classList.contains(classes.visible)) return;

    if (window.theme && typeof window.theme.setVars === 'function') {
      window.theme.setVars();
    }

    filters.classList.add(classes.visible);

    document.dispatchEvent(
      new CustomEvent('theme:scroll:lock', {
        bubbles: true,
        detail: filters.querySelector(selectors.filtersList)
      })
    );
  }

  function close(filters) {
    if (!filters || !filters.classList.contains(classes.visible)) return;

    filters.classList.remove(classes.visible);

    document.dispatchEvent(
      new CustomEvent('theme:scroll:unlock', {
        bubbles: true,
        detail: SCROLL_UNLOCK_DELAY
      })
    );
  }

  function openSections() {
    var sections = document.querySelectorAll(
      selectors.section + '.' + classes.drawerMode
    );

    return Array.prototype.filter.call(sections, function (section) {
      var filters = getFilters(section);

      return filters && filters.classList.contains(classes.visible);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(selectors.trigger);

    if (trigger) {
      var section = trigger.closest(selectors.section);

      if (!section || !section.classList.contains(classes.drawerMode)) return;

      event.preventDefault();

      var filters = getFilters(section);

      if (!filters) return;

      if (filters.classList.contains(classes.visible)) {
        close(filters);
      } else {
        open(filters);
      }

      return;
    }

    if (!isDesktop()) return;

    // Click outside the panel (on the dimmed page) closes it.
    openSections().forEach(function (section) {
      var filters = getFilters(section);

      if (!filters.contains(event.target)) close(filters);
    });
  });

  document.addEventListener('keyup', function (event) {
    if (event.code !== 'Escape' && event.key !== 'Escape') return;

    openSections().forEach(function (section) {
      close(getFilters(section));
    });
  });
})();
